/* unplugin-vue-components disabled */import { render } from "./StudentCourseTableNew.vue?vue&type=template&id=7af398df&scoped=true"
import script from "./StudentCourseTableNew.vue?vue&type=script&lang=js"
export * from "./StudentCourseTableNew.vue?vue&type=script&lang=js"

import "./StudentCourseTableNew.vue?vue&type=style&index=0&id=7af398df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af398df"]])

export default __exports__